import { Tree } from 'antd';
import React, { useEffect, useState } from 'react';
import { getPhysics } from '@/services/source';
import CategoryName from './components/CategoryName';
import styles from './index.module.less';

interface Props {
  title: string;
}

const formatData: any = (list: any) => {
  return (
    list.map((item: any) => {
      return {
        id: item.category,
        key: item.category,
        title: item.category,
        count: item.linkMaterialCnt,
        pid: '',
        _changed: false, // 是否修改标记，用于更新收集
        children: item?.childs ? formatData(item.childs) : [],
      };
    }) || []
  );
};
const CategorySetting: React.FC<Props> = (props: Props) => {
  const { title } = props;
  const [settingDataTree, setSettingDataTree] = useState<any[]>([]);

  const fetchCategoryOptions = async () => {
    const res = await getPhysics(true);
    if (res?.success) {
      setSettingDataTree(formatData(res?.data?.details) || []);
    }
  };

  useEffect(() => {
    fetchCategoryOptions();
  }, []);

  const titleRender = (data: any) => {
    return <CategoryName category={data}></CategoryName>;
  };

  return (
    <div className={styles.patternWrap}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        {/* <div className={styles.addTreeItem} onClick={() => setIsAddingLevel1(true)}>
          <Button size="middle" type="default">
            新增一级分类
          </Button>
        </div> */}
      </div>

      <div className={styles.body}>
        <Tree
          blockNode={true}
          treeData={settingDataTree}
          draggable={false}
          titleRender={titleRender}
        />
      </div>
      <div className={styles.footer}></div>
    </div>
  );
};

export default React.memo(CategorySetting);
